import { animated } from './react-spring'
import { TYPES } from './utils/element'

export * from './exports'

export const BitmapText = animated[TYPES.BitmapText]
export const Container = animated[TYPES.Container]
export const Graphics = animated[TYPES.Graphics]
export const NineSlicePlane = animated[TYPES.NineSlicePlane]
export const ParticleContainer = animated[TYPES.ParticleContainer]
export const Sprite = animated[TYPES.Sprite]
export const AnimatedSprite = animated[TYPES.AnimatedSprite]
export const Text = animated[TYPES.Text]
export const TilingSprite = animated[TYPES.TilingSprite]
export const SimpleMesh = animated[TYPES.SimpleMesh]
export const SimpleRope = animated[TYPES.SimpleRope]
